import React, { useEffect } from 'react';
import { CollaborationIconMap } from 'components/organisms/customer-portal/portal-inputs/render-as/collaboration-icon-config-input';
import { CpSectionWrapper } from '../../common';
import { CpLogoWidgetRendererProps } from '../cp-logo-section';
import {
  LogoDivider,
  LogoSectionWrapper,
  LogoWrapper,
  LogoContainer,
  StyledAvatar,
  StyledImage,
} from './logo-section-with-header';

export const CpLogoWithoutHeader: React.FC<CpLogoWidgetRendererProps> = ({
  disabled,
  data,
  widget,
}) => {
  const [isIconEnabled, setIsIconEnabled] = React.useState(
    (data?.collaborationIconConfig as any).isIconEnabled as boolean,
  );

  useEffect(() => {
    setIsIconEnabled((data?.collaborationIconConfig as any).isIconEnabled);
  }, [data?.collaborationIconConfig]);

  return (
    <CpSectionWrapper
      paddingY={widget?.widgetDefinition?.styles?.paddingY as number}
      isDisabled={disabled}
      background={widget?.widgetDefinition?.styles?.background as string}
    >
      <LogoSectionWrapper isCollaborationIconAvailable={isIconEnabled}>
        <LogoWrapper data-cy="cp.logo_without_header.vendor_logo">
          <StyledAvatar
            size="large"
            shape="square"
            key={(data?.vendorLogo as unknown as any).companyId}
            name={(data?.vendorLogo as unknown as any).companyName}
            src={(data?.vendorLogo as unknown as any).companyLogoUrl}
          />
        </LogoWrapper>
        <LogoDivider>
          {isIconEnabled && (
            <LogoContainer>
              {
                CollaborationIconMap[
                  (data.collaborationIconConfig as unknown as any)?.iconType
                ].largeIcon
              }
            </LogoContainer>
          )}
        </LogoDivider>
        <LogoWrapper data-cy="cp.logo_without_header.customer_logo">
          {data?.customerLogo ? (
            <StyledImage src={data?.customerLogo} />
          ) : (
            <StyledAvatar
              size="large"
              shape="square"
              name={data?.customerLogo}
              src={data?.customerLogo}
            />
          )}
        </LogoWrapper>
      </LogoSectionWrapper>
    </CpSectionWrapper>
  );
};
